import { urlHome, urlSuccess } from "../../urls";
import { CheckCircle, CircleCheck } from "lucide-react";
import { formatDate, DateFormat } from "@repo/ui/lib/format/format-date";
import { useSendEvent } from "../../hooks/use-send-event";
import { useEffect, useRef, useState } from "react";
import { playerAtom, productsAtom } from "../../stores/pos";
import { useAtom } from "jotai";
import { Button } from "@repo/ui/components/button";
import { Link, useNavigate } from "react-router";

const COUNTDOWN = 5;

function Success() {
  const sendEvent = useSendEvent();
  const [player, setPlayer] = useAtom(playerAtom);
  const [products, setProducts] = useAtom(productsAtom);
  const navigate = useNavigate();
  const timeout = useRef<ReturnType<typeof setInterval> | null>(null);
  const [countdown, setCountdown] = useState(COUNTDOWN);

  useEffect(() => {
    setProducts([]);
    setPlayer(null);
    setCountdown(COUNTDOWN);
    timeout.current = setInterval(() => {
      setCountdown((prev) => {
        const newValue = prev - 1;
        return newValue;
      });
    }, 1000);
    return () => {
      if (timeout.current) {
        clearInterval(timeout.current);
      }
    };
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      navigate(urlHome(), { viewTransition: true });
    }
  }, [countdown]);

  useEffect(() => {
    sendEvent("sale_success", {
      products: products,
      player: player,
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-2 h-full w-full max-w-lg mx-auto">
      <div className="flex flex-col items-center justify-center gap-8 bg-white border p-8 rounded-xl shadow-md w-full">
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="flex items-center justify-center p-4 rounded-full bg-green-500/10 mb-4">
            <CheckCircle className="size-14 text-green" />
          </div>
          <p className="text-3xl text-gray-700 text-center font-bold">
            ¡Venta registrada!
          </p>
          <p className="text-md text-gray-500 text-center">
            Los artículos se han registrado correctamente en tu cuenta.
          </p>
          <p className="text-md text-gray-500 text-center">
            Que disfrutes tu juego!
          </p>
        </div>
        <div className="bg-gray-100 p-4 rounded-lg shadow-md w-full flex flex-col gap-4">
          <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between text-sm">
              <p className="text-gray-400 flex items-center gap-1">Estado</p>
              <p className="text-gray-400 flex items-center gap-1">Fecha</p>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1 text-green">
                <CircleCheck className="size-4 fill-green stroke-white" />
                Confirmado
              </div>
              <p className="font-medium">
                Hoy, {formatDate(new Date(), DateFormat.HH_MM)}
              </p>
            </div>
          </div>
        </div>
        <Button
          variant="pos"
          size="3xl"
          className="w-full text-lg! font-medium! py-3 rounded-xl"
          asChild
        >
          <Link to={urlHome()} viewTransition>
            Volver al inicio
          </Link>
        </Button>
      </div>
      <div className="text-sm text-gray-500 text-center">
        Se cerrará automáticamente en{" "}
        <span className="font-medium text-primary">
          {countdown.toString()}s.
        </span>
      </div>
    </div>
  );
}

export const route = {
  element: <Success />,
  path: urlSuccess(),
};
